import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Image from 'utils/image';
import extractAndFormat from '../utils/extract-and-format';
import { formatMoney } from 'utils/storefront/format-resource';


export const YouMayAlsoLike = ({ youMayAlsoLikeData, cart }) => {
  const { title, products, minPriceArr, maxPriceArr } = youMayAlsoLikeData;
  const cartItems = cart.state.items || [];
  const cartTotal = cart.state.total_price || 0;

  // State to hold unique products
  const [uniqueProducts, setUniqueProducts] = useState([]);

  useEffect(() => {
    const filteredUniqueProducts = [];
    
    products.forEach((productArray, index) => {
      // Calculate the conditions for filtering products
      const minConditionValue = (minPriceArr[index] * 100) || 0;
      const maxConditionValue = (maxPriceArr[index] * 100) || Infinity;

      const validProducts = productArray.filter(({ productVariant }) => {
        if (cartItems.length > 0) {
          const isInCart = cartItems.some((item) => item.id === productVariant.id); // the current variant is not in the cart
          
          return (
            !isInCart && 
            productVariant.available &&
            cartTotal >= minConditionValue &&
            cartTotal <= maxConditionValue
          );
        } else {
          return (
            productVariant.available &&
            cartTotal >= minConditionValue &&
            cartTotal <= maxConditionValue
          );
        }
      });

      // Select the first valid product from the current array, if any
      if (validProducts.length > 0) {
        const { product, description, productVariant, price } = validProducts[0]; // Pick the first valid product
        filteredUniqueProducts.push({ product, description, productVariant, price });
      }
    });

    // Update the unique products state
    setUniqueProducts(filteredUniqueProducts);
  }, [products, cart.state.items, cart.state.total_price, minPriceArr, maxPriceArr]);

  // Return null if there are no unique products
  if (uniqueProducts.length === 0) {
    return null;
  }

  return (
    <div className="px-5 pt-4 pb-6 bg-grey-F7">
      {title && <p className="text-grey-2A mb-[6px] font-light">{title}</p>}
      <div className="flex flex-col gap-y-[6px]">
        {uniqueProducts.map(({ product, description, productVariant, price }) => (
          <YouMayAlsoLikeProduct
            key={product.id}
            product={product}
            description={description}
            variant={productVariant}
            price={price}
          />
        ))}
      </div>
    </div>
  );
};

const YouMayAlsoLikeProduct = ({ product, description, variant, price }) => {
  const handleAddToCart = (e) => {
    e.preventDefault();
    const addToCartEvent = new CustomEvent('cart:add', {
      detail: {
        payload: {
          merchandiseId: `${variant.id}`,
          quantity: 1,
        },
      },
    });
    document.dispatchEvent(addToCartEvent);
  };

  return (
    <div style={{ boxShadow: '0 0 6px 0 rgba(0, 0, 0, 0.1)' }} className="bg-grey-FA flex p-[10px] items-center">
      <div className="w-full flex max-w-[58px] lg:max-w-[65px]">
        <Image
          src={variant.featured_image?.src || variant.featured_image || product.featured_image}
          classes="block object-contain w-full h-auto"
          alt={variant.featured_image?.alt || ''}
        />
      </div>
      <div className="pl-[10px] text-[12px]">
        <div className="body-sm text-sm mb-[2px]">{product.title}</div>
        {description && <div className="text-grey-5C">{description}</div>}
        <button
          className="cta-medium no-underline text-[10px] mt-[6px] tracking-[1px]"
          onClick={handleAddToCart}
        >
          {window.TMW.Strings.product.addToCart} - {extractAndFormat(formatMoney({ amount: price }, true))}
        </button>
      </div>
    </div>
  );
};
